import React, { useState, useEffect } from 'react';
import homeIcon from './../../Constant/Icons/dashboard.svg';
// import info from './../../Constant/Icons/info.svg';
import services from '../../Constant/Icons/services.svg';
import payment from '../../Constant/Icons/payment.svg';
import seatManipulation from '../../Constant/Icons/seat.png';
import appIcon from '../../Constant/Icons/application.svg';
import appStats from '../../Constant/Icons/appStatus.svg'
import staffIcon from '../../Constant/Icons/staff.svg';
import rankIcon from '../../Constant/Icons/rank.svg';
import { useLocation, useNavigate } from 'react-router-dom';

function AdminSideBar({ accesslvl, onRouteChange }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const location = useLocation(); // Hook to get the current URL
  const navigate = useNavigate();


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Function to handle route changes, both from sidebar and other sources
  const handleRouteChange = (route) => {
    if (location.pathname !== route) {
      navigate(route); // Navigate programmatically
      onRouteChange(route); // Callback if needed
    }
  };

  useEffect(() => {
    setIsSidebarOpen(window.innerWidth >= 1024);
  }, [window.innerWidth])

  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
      <button className="toggle-btn" onClick={toggleSidebar}>
        {isSidebarOpen ? "☰" : "☰"}
      </button>
      <ul>
        {accesslvl !== "S" && (
          <>
            <li
              onClick={() => handleRouteChange("/admin/dashboard")}
              className={
                location.pathname === "/admin/dashboard" ? "active" : ""
              }
            >
              <img src={homeIcon} alt="Dashboard" width={20} height={20} />
              {isSidebarOpen ? <span>Dashboard</span> : null}
            </li>
            <li
              onClick={() => handleRouteChange("/admin/dashboard/seat-manipulation")}
              className={
                location.pathname === "/admin/dashboard/seat-manipulation" ? "active" : ""
              }
            >
              <img src={seatManipulation} alt="Seat-Manipulation" width={20} height={20} />
              {isSidebarOpen ? <span>Seat Manipulation</span> : null}
            </li>
          </>
        )}

        {accesslvl !== "J" && accesslvl !== "S" && (
          <>
            <li
              onClick={() => handleRouteChange("/admin/dashboard/services")}
              className={
                location.pathname === "/admin/dashboard/services"
                  ? "active"
                  : ""
              }
            >
              <img src={services} alt="Services" width={20} height={20} />
              {isSidebarOpen ? <span>Services</span> : null}
            </li>
            <li
              onClick={() =>
                handleRouteChange("/admin/dashboard/payment-services")
              }
              className={
                location.pathname === "/admin/dashboard/payment-services"
                  ? "active"
                  : ""
              }
            >
              <img src={payment} alt="Payment" width={20} height={20} />
              {isSidebarOpen ? <span>Payments</span> : null}
            </li>
          </>
        )}



        <li
          onClick={() =>
            handleRouteChange("/admin/dashboard/application-services")
          }
          className={
            location.pathname === "/admin/dashboard/application-services"
              ? "active"
              : ""
          }
        >
          <img src={appIcon} alt="application" width={20} height={20} />
          {isSidebarOpen ? <span>Applications</span> : null}
        </li>

        <li
          onClick={() => handleRouteChange("/admin/dashboard/cv")}
          className={
            location.pathname === "/admin/dashboard/cv" ? "active" : ""
          }
        >
          <img src={staffIcon} alt="CV" width={20} height={20} />
          {isSidebarOpen ? <span>CV</span> : null}
        </li>

        <li
          onClick={() =>
            handleRouteChange("/admin/dashboard/admin-daily-stats")
          }
          className={
            location.pathname === "/admin/dashboard/admin-daily-stats"
              ? "active"
              : ""
          }
        >
          <img src={appStats} alt="Services" width={20} height={20} />
          {isSidebarOpen ? <span>Daily Statistics</span> : null}
        </li>
        {accesslvl !== "J" && accesslvl !== "S" && (
          <>

            <li
              onClick={() =>
                handleRouteChange("/admin/dashboard/rank-services")
              }
              className={
                location.pathname === "/admin/dashboard/rank-services"
                  ? "active"
                  : ""
              }
            >
              <img src={rankIcon} alt="Rank" width={20} height={20} />
              {isSidebarOpen ? <span>Rank Services</span> : null}
            </li>

          </>
        )}
      </ul>
    </div>
  );
}

export default AdminSideBar;
